import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.FossilFinder;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "FossilFinder.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "FossilFinder.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "FossilFinder.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/FossilFinderGame/scenes/IntroductionScene.ts